/**
 * An enum that represents filter cases
 */
export enum FilterCase {
  /** Case insensitive */
  CaseInsensitive,

  /** Case sensitive */
  CaseSensitive
}
